module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAnUlEQVRIx2O4pylAI8SAR+5tBee7eg7qGP0smAeIEEZXcr5vp5LRn6azARGaine1HG+rOMk3+mUa9++TTP/vMgARkPEynRuu4kM3+9saTopc/SyU5/89kNFABpWj8UMf++dZbJ9nsgEZyCqAwf2+hYMiox878qExoJFZy0lpgGBJfNWc75s4aJOu6zjJCwrCRtMwN44aPWr0qNEYCADuepykH+FanwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cn.png
// module id = 801
// module chunks = 0